import React from "react";
import { Card, Button } from "antd";

const DisplayCard = ({
  icon,
  title,
  heading,
  description,
  buttonText,
  buttonDisabled = false,
}) => {
  return (
    <Card bordered className="p-4" style={{ maxWidth: "530px" }}>
      <p style={{ color: "red" }}>
        <span className="anticon">{icon}</span>
        <span className="ml-2">{heading}</span>
      </p>
      <h4>{title}</h4>
      <p>{description}</p>
      <Button type="primary" disabled={buttonDisabled}>
        {buttonText}
      </Button>
    </Card>
  );
};

export default DisplayCard;
